import { actionGenerator, IReduxAction } from '../../redux/actionGenerator';

export const OPEN_MODAL = 'MODAL :: OPEN';

interface IModalPayload {
  name: string;
  data?: object;
}

export type TOpenModalAction = IReduxAction<typeof OPEN_MODAL, IModalPayload>;

export const openModal = actionGenerator<typeof OPEN_MODAL, IModalPayload>(OPEN_MODAL);
